import axios from "axios";

export default {
  methods: {
    async downloadFile(item) {
      this.isLoading = true;
      try {
        const response = await axios({
          url: item.url,
          method: "GET",
          responseType: "blob"
        });
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", `${item.name}.${item.ext}`);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.$dialog.notify.success("Su descarga iniciara pronto", {
          position: "top-right",
          timeout: 5000
        });
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      } finally {
        this.isLoading = false;
      }
    }
  }
};
